import type { ChangelogEntry } from './changelog-types';

/**
 * Versões anteriores — resumo em PT-BR a partir de https://wiki.xat.com/Changelog
 * (detalhes muito extensos, p.ex. 1.63, foram agrupados por tema).
 */
export const changelogLegacy: ChangelogEntry[] = [
  {
    version: '1.63',
    date: '30 de outubro de 2023',
    sections: [
      {
        type: 'improvement',
        label: 'Melhorias',
        count: 2,
        items: [
          { title: 'App de troca: traduções passam a aparecer (quando disponíveis).' },
          {
            title: 'Loja de powers (web)',
            details: [
              'Botão “ir ao fim” em páginas longas.',
              'Filtro repõe estado corretamente.',
              'Aba Allpowers.',
              'Loja mais rápida; abre em Latest powers.',
              'Carrinho com resumo e edição.',
            ],
          },
        ],
      },
      {
        type: 'new',
        label: 'Web',
        count: 1,
        items: [
          { title: 'Twitter renomeado para X (ícone e nome).' },
        ],
      },
      {
        type: 'fix',
        label: 'Correções (chat, mobile e web)',
        count: 4,
        items: [
          {
            title: 'Chat — grupos, perfil, tradutor e moderação',
            details: [
              'Salvar chat favorito em PC grava corretamente.',
              'Ícone Apps em telas pequenas sem transbordar.',
              'Mensagens de sucesso ao atribuir/desatribuir vários powers.',
              'Alguns GIFs como link; cor do seletor no perfil; tradutor/dias (Category); botão Visitante.',
              'BFF/casamento desconectando: peão limpo; backs sobre smilies; idioma de presentes; tradutor com aspas.',
              'Heart com combinações; som de kiss; limite de main owners; Manage main owner e senha.',
              '$status= com emoji; macros longos; stickers sem power; vários assigns; PCPlus reflete no botão PM.',
              'PM com tradutor; copiar/colar; gameban e autosignin; PCBack com toon; formatação duplicada.',
              'Zap, Gcontrol, gag e PC; #none em smilies; busca/valores na Trade.',
            ],
          },
          {
            title: 'Chat — mensagens, UI e powers',
            details: [
      'Perfil de presentes, aniversários de casamento/BFF, nomes vazios na lista, som (bomb) com chat mudo.',
              'Configurações após receber dia/power; size transbordando; dados de PC como ID; PM “sair”; URLs.',
              'Gradiente de pré-visualização por idioma; pasta de reações vazia; URLs formatadas.',
            ],
          },
          {
            title: 'App mobile (10 correções)',
            details: [
              'Registro pelo e-mail; lost password sem feedback; chats redirecionados em listas.',
              'Loja de powers com smilies a transbordar; logo abria página vazia; audies no iOS.',
              'Cookies para Quickbar; 8ball mantém código; Store no perfil sem efeito.',
            ],
          },
          {
            title: 'Web — xatspace, anúncios e grupos',
            details: [
              'Casados/BFF no espaço; avatar em telas pequenas; clique em banner ia para loja.',
              'Banners só após refresh/duração; promoções somam tempo corretamente.',
              'Criar grupo sem login bloqueado; Gcontrol em promoções; menu mobile com clique fantasma.',
              'Busca na home; hover com nome do smiley no banner; recuperação de grupo; GIFs no xatspace.',
            ],
          },
        ],
      },
    ],
  },
  {
    version: '1.62',
    date: '13 de julho de 2023',
    sections: [
      {
        type: 'new',
        label: 'Novidades no Chat',
        count: 4,
        items: [
          {
            title: 'Menu de mensagem',
            details: ['Copiar mensagem, copiar smiley e copiar link no clique direito.'],
          },
          {
            title: 'Ultra smilies',
            details: [
              'Ex.: Angel, Bugs, Bomb, SS, Parachute, Shark, Focushion, Mario8, Lights animam ao passar o mouse.',
            ],
          },
          { title: 'Smilies de power com brilho; peão pulsa brevemente ao enviar mensagem.' },
          {
            title: 'Tradutor',
            details: ['Língua bósnia adicionada.'],
          },
        ],
      },
      {
        type: 'improvement',
        label: 'Melhorias',
        count: 3,
        items: [
          { title: 'Hashtag (#) com palavra inexistente mostra texto em vez de Audies.' },
          { title: 'Com Animate, avatar pode ser .gif direto (sem converter para strip PNG).' },
          { title: 'Não assinantes veem quem reagiu às mensagens.' },
        ],
      },
      {
        type: 'fix',
        label: 'Correções de Bugs',
        count: 7,
        items: [
          { title: 'GIFs às vezes não carregavam em alguns chats; peões Ruby/Gold/EP alinhados.' },
          { title: 'Nameglow desligado + gradiente quebrava ícone de app na lista de visitantes.' },
          { title: 'Citação com Keywords; links em citações estendendo formatação; tradução em pop-ups.' },
          { title: '(powers) com um power ativo; smilies clicáveis bloqueando cliques; invert em avatar com espaço extra.' },
          { title: 'Scroll: URLs sem Linkvalidator; 8ball e PM/tab names; gag + flgpwn; lista de visitantes e tooltips.' },
          { title: 'Lista mobile/teclado e group power ao trocar abas.' },
          {
            title: 'Web',
            details: ['Anúncios de powers abrem loja em nova aba; login com mensagem ao salvar.', 'xatspace “hide inner” sem fundo vazio.'],
          },
        ],
      },
    ],
  },
  {
    version: '1.61.2',
    date: '16 de dezembro de 2022',
    sections: [
      {
        type: 'fix',
        label: 'Correções de Bugs',
        count: 3,
        items: [
          { title: 'Silenciar usuário: mensagens reapareciam ao desconectar; corrigido.' },
          { title: 'Transferência/troca às vezes reconectava sem mensagem de erro; corrigido.' },
          { title: 'Reverse ban não funcionava; corrigido.' },
        ],
      },
    ],
  },
  {
    version: '1.61',
    date: '17 de setembro de 2022',
    sections: [
      {
        type: 'new',
        label: 'Novidades',
        count: 1,
        items: [
          {
            title: 'GIFs no chat',
            details: ['Uso pela Quickbar para usuários registrados (ver anúncio no fórum).'],
          },
        ],
      },
      {
        type: 'improvement',
        label: 'Melhorias',
        count: 1,
        items: [
          { title: 'Botões no diálogo de usuário desativados se o rank não corresponder ao Gcontrol.' },
        ],
      },
      {
        type: 'fix',
        label: 'Correções',
        count: 7,
        items: [
          { title: 'Reação não move scroll exceto na última mensagem; login em outro browser perde configurações no anterior.' },
          { title: 'URLs com underscore em kick/ban; toon sem ID como visitante abaixo das pools; /t em PM não fechava aba.' },
          { title: 'Anula animação na barra de smilies; Nameflags #u com animações desligadas; Announce com colchetes.' },
          { title: 'Menu M/B ID; ícone fechar PC no modo noturno; altura do diálogo de smilies; banish após reconectar.' },
          { title: 'Gameban forever não iniciava; categoria de amigo offline; Drawn/Fools/Bad e 8ball mobile.' },
          { title: 'Mobile: avatar bloqueado na lista vs chat; ler próprios gifts privados; ID em PM com não registrado; Goodfriend.' },
          { title: 'Web: bandeiras Gstyle e novas (arco-íris, pata, pirata).' },
        ],
      },
    ],
  },
  {
    version: '1.60',
    date: '2 de junho de 2022',
    sections: [
      {
        type: 'new',
        label: 'Novidades',
        count: 2,
        items: [
          {
            title: 'Bloqueio (Block)',
            details: [
              'Bloqueado não vê status, página inicial, gifts ou avatar (só reg/ID e powers).',
              'Não pode PC/M PM/casamento-BFF/transfer; moderador vê “Blocked user”.',
              'Some da lista de visitantes e mensagens; remove da friendlist se era amigo.',
            ],
          },
          {
            title: 'App Android',
            details: ['Foco nesta versão; disponível na Play Store.'],
          },
        ],
      },
      {
        type: 'improvement',
        label: 'Melhorias',
        count: 2,
        items: [
          { title: 'Quickbar “Mais”: listas Ignorados e Bloqueados.' },
          { title: 'Gestor de powers de grupo redesenhado (incl. mobile); Quickbar no mobile PWA.' },
        ],
      },
      {
        type: 'fix',
        label: 'Correções',
        count: 1,
        items: [{ title: 'Comando /o removido após login; RTL e página de configurações instáveis; corrigidos.' }],
      },
      {
        type: 'new',
        label: 'Web',
        count: 1,
        items: [{ title: 'Banner se grupo antigo não usado pode ser comprado.' }],
      },
    ],
  },
  {
    version: '1.59',
    date: '28 de fevereiro de 2022',
    sections: [
      {
        type: 'new',
        label: 'Novidades no Chat',
        count: 2,
        items: [
          {
            title: 'Tags em scroll e announce',
            details: ['{id} {regname} {nickname} {userscount} {latestpower} {rank} {chatversion}'],
          },
          {
            title: 'Gestor de powers de grupo (Quickbar)',
            details: [
              'Quantos já atribuídos no chat; quantos ainda podem ser atribuídos.',
              'Atribuir ou desatribuir vários powers de uma vez.',
            ],
          },
        ],
      },
      {
        type: 'improvement',
        label: 'Melhorias',
        count: 2,
        items: [
          { title: 'Data de casamento/BFF em novo formato.' },
          {
            title: 'Mod+ apaga mensagem de outros sem refresh; some na hora para quem vê.',
          },
        ],
      },
      {
        type: 'fix',
        label: 'Correções',
        count: 3,
        items: [
          { title: 'Namewave sem possuir; escala da janela de presentes; Whitelist com caracteres especiais na URL.' },
          { title: 'Tradutor com números aleatórios; data M/B com gifts; várias em Editar mensagem.' },
          { title: 'Tickle $1; clique em quem te cutucou; PWA trocar web/app; múltipla compra de power; Tickle; ruby verde.' },
        ],
      },
      {
        type: 'new',
        label: 'Web',
        count: 2,
        items: [
          { title: 'TikTok no xatspace como rede social.' },
          { title: 'Navbar em ecrãs pequenos (revertido autohide); mais anúncios de grupo.' },
        ],
      },
    ],
  },
  {
    version: '1.58',
    date: '9 de dezembro de 2021',
    sections: [
      {
        type: 'new',
        label: 'Novidades',
        count: 2,
        items: [
          { title: 'Atribuir group powers pela Quickbar (melhorias futuras planejadas).' },
          { title: 'Superkick implementado.' },
        ],
      },
      {
        type: 'improvement',
        label: 'Melhorias',
        count: 1,
        items: [
          { title: 'Letra I como i no diálogo de usuário; gamebans listados à parte na janela de ban.' },
        ],
      },
      {
        type: 'fix',
        label: 'Correções',
        count: 2,
        items: [
          { title: 'Peões de super-coleções; idioma vazio ao mudar no site; /go e barra de smilies.' },
          { title: 'Citar mensagem vazia com aninhado; redcard “Forever”; dunce mesmo rank; PM não entregue.' },
        ],
      },
      {
        type: 'new',
        label: 'Web',
        count: 3,
        items: [
          { title: 'Confirmação de novo dispositivo; ferramenta de conversão de animação com GIF; nova página de pesquisa.' },
          { title: 'Power Gstyle de grupo; rankpool até 19 caracteres; loja sem separador “featured”.' },
          { title: 'Promo na home em mobile substituída; flagname visível no hover no xatspace; abas de grupos permanecem fechadas.' },
        ],
      },
      {
        type: 'fix',
        label: 'Web — correções',
        count: 1,
        items: [
          { title: 'editgroup em modo código; ícone fechar no Trade.' },
        ],
      },
    ],
  },
  {
    version: '1.57',
    date: '12 de novembro de 2021',
    sections: [
      {
        type: 'powers',
        label: 'Powers',
        count: 2,
        items: [
          { title: 'Whitelist (power de grupo).' },
          { title: 'Snakerace refeito e jogável de novo.' },
        ],
      },
      {
        type: 'fix',
        label: 'Correções',
        count: 2,
        items: [
          { title: 'Cutucar/PC de outro chat às vezes sem dados do usuário.' },
          { title: 'Tradução de PM vazando para o chat principal.' },
        ],
      },
    ],
  },
  {
    version: '1.56',
    date: '8 de outubro de 2021',
    sections: [
      {
        type: 'new',
        label: 'Novidades',
        count: 2,
        items: [
          {
            title: 'Menu de contexto da mensagem',
            details: [
              'Botão direito (mobile: pressionar): citar, traduzir, apagar, reagir, editar; timestamps no menu.',
            ],
          },
          {
            title: 'Editar mensagens',
            details: ['Indicação de editado com texto antigo; até 2 minutos; via menu.'],
          },
        ],
      },
      {
        type: 'improvement',
        label: 'Melhorias',
        count: 4,
        items: [
          { title: 'Mod+ vê mensagens ignoradas; SHIFT+Ignorar como membro.' },
          { title: 'Goodfriend nas configurações; Bump só amigos/rank maior.' },
          { title: 'Lista de visitantes/amigos em largura total; botão “Editar amigo” com várias opções.' },
          { title: 'Redesign geral do chat: botões, hover, fechar, transição de pop-ups.' },
        ],
      },
      {
        type: 'fix',
        label: 'Correções (lista extensa na wiki)',
        count: 1,
        items: [
          {
            title: 'Typing, Away, reações, ranks invisíveis, stealth, pools, links, citações e muito mais',
            details: [
              'Corrigidos dezenas de bugs listados na wiki (lápis digitando, Blueman/Pink, Rapid, boot, tradutor, etc.).',
            ],
          },
        ],
      },
    ],
  },
  {
    version: '1.55.4',
    date: '6 de agosto de 2021',
    sections: [
      {
        type: 'improvement',
        label: 'Melhorias',
        count: 2,
        items: [
          { title: 'Hands: opções avançadas (ex.: cd#thumbsup#left#still).' },
          { title: 'Presentes: indicador de carregamento para evitar envios duplos.' },
        ],
      },
      {
        type: 'fix',
        label: 'Correções',
        count: 1,
        items: [
          { title: 'Reações “quem reagiu” ao trocar abas; bandeiras sem classic; link eventos em PC.' },
        ],
      },
    ],
  },
  {
    version: '1.55.3',
    date: '22 de julho de 2021',
    sections: [
      {
        type: 'powers',
        label: 'Powers',
        count: 1,
        items: [{ title: 'Suporte ao power Bantimes.' }],
      },
      {
        type: 'improvement',
        label: 'Melhorias',
        count: 2,
        items: [
          { title: 'Mensagens iguais consecutivas permitidas.' },
          { title: 'Scroll manual para cima não é puxado para baixo por mensagens novas.' },
        ],
      },
      {
        type: 'fix',
        label: 'Correções',
        count: 1,
        items: [{ title: 'Away padrão 300s (era mostrado 60); /o e tooltips.' }],
      },
    ],
  },
  {
    version: '1.55.1',
    date: '3 de julho de 2021',
    sections: [
      {
        type: 'improvement',
        label: 'Melhorias',
        count: 3,
        items: [
          { title: 'Tempo de ban padrão = 1.' },
          { title: 'Banner animado de power desligado por defeito (ligar nas configurações).' },
          { title: 'Possível ganho de desempenho.' },
        ],
      },
      {
        type: 'fix',
        label: 'Correções',
        count: 1,
        items: [{ title: 'Statusfx longo desalinha peão; /o; links aleatórios.' }],
      },
    ],
  },
  {
    version: '1.55',
    date: '22 de junho de 2021',
    sections: [
      {
        type: 'new',
        label: 'Novidades',
        count: 3,
        items: [
          {
            title: 'Reações a mensagens (assinantes)',
            details: ['Reagir com smilies.'],
          },
          {
            title: 'Contador de usuários (registrados)',
            details: ['Hover no número; total na Quickbar.'],
          },
          { title: 'Power Gsound.' },
        ],
      },
      {
        type: 'improvement',
        label: 'Melhorias',
        count: 3,
        items: [
          {
            title: 'Quickbar: design, botão voltar, Stealth para owners por toggle (sem $ no nome).',
          },
          {
            title: 'YouTube no chat: volume, botões para app lateral e configurações.',
          },
          {
            title: 'Translator: vazamento PM→main corrigido; esconder original; main/PC separado; permanece ativo no chat.',
          },
        ],
      },
      {
        type: 'fix',
        label: 'Correções (muitas na wiki)',
        count: 2,
        items: [
          {
            title: 'Pacote de correções 1.55',
            details: [
              '8ball azul em oficiais; bump só em PC; allpowers [2]; stickers; four in a row; gameban; stealth; convidado ciano; Chrome qualidade; vírgulas no status; macros em PM; botões editar chat; Rapid; transfer; boot; invisível em kick; pool messages; etc.',
            ],
          },
          { title: 'PWA: tradutor, botão instalar, fechar após transfer, campos longos editáveis.' },
        ],
      },
    ],
  },
  {
    version: '1.54.1',
    date: '2 de abril de 2021',
    sections: [
      {
        type: 'fix',
        label: 'Correções',
        count: 2,
        items: [
          { title: 'Statusfx: campo vazio quebrava config; casados/BFF; caracteres especiais; posição no PWA.' },
          { title: 'YouTube no PWA; botão PM; bug crítico mostrando chat errado no grupo.' },
        ],
      },
    ],
  },
  {
    version: '1.54',
    date: '26 de março de 2021',
    sections: [
      {
        type: 'new',
        label: 'Novidades',
        count: 2,
        items: [
          {
            title: 'Tradução rápida por mensagem',
            details: ['Ícone Traduzir ao lado do nome; clique na tradução mostra original.'],
          },
          {
            title: 'Powers e recursos',
            details: [
              '(folded) free ex-(pray); smilies em falta; Audies; Banish; Random; Supercycle; Zap; blasts; Lang atualizado.',
            ],
          },
        ],
      },
      {
        type: 'improvement',
        label: 'Melhorias',
        count: 4,
        items: [
          { title: 'Temp rank mostra tempo exato; auto sign-in menos intrusivo.' },
          { title: 'Lista de powers com smiley principal; 8ball mostra todas as variantes; sons em todas as abas.' },
          { title: 'Timestamps dinâmicos (“há X seg”); scroll com cor em links; ícone ajuda nas configurações.' },
          { title: 'Contador real de não lidas no hover da aba.' },
        ],
      },
      {
        type: 'fix',
        label: 'Correções',
        count: 1,
        items: [
          {
            title: 'Amplas correções: diálogo de usuário, reverse/zipban, wallet, embed, nopc/nopm, pool, volume, captcha, Namewave, casamento/gag, amigos, nomes inadequados.',
          },
        ],
      },
    ],
  },
  {
    version: '1.52.1',
    date: '29 de dezembro de 2020',
    sections: [
      {
        type: 'improvement',
        label: 'Melhorias',
        count: 1,
        items: [{ title: 'Animações só com rato sobre a caixa do chat (menos CPU).' }],
      },
      {
        type: 'fix',
        label: 'Correções',
        count: 1,
        items: [
          { title: 'Definição “desligar animações”; conexão travada; extensões do browser que impediam carregar grupo.' },
        ],
      },
    ],
  },
  {
    version: '1.52',
    date: '4 de dezembro de 2020',
    sections: [
      {
        type: 'new',
        label: 'Novidades (mobile/PWA)',
        count: 1,
        items: [
          {
            title: 'Grupos no browser em mobile abrem a app',
            details: [
              'Novas configurações, fundos portrait/landscape, pesquisa, notificações, keywords (Mark), captcha novo.',
              'Muitas funcionalidades HTML5 em mobile.',
            ],
          },
        ],
      },
      {
        type: 'fix',
        label: 'Correções',
        count: 1,
        items: [{ title: 'Apps Flash por links; Category na friendlist; Youtube.' }],
      },
    ],
  },
  {
    version: '1.51',
    date: '10 de outubro de 2020',
    sections: [
      {
        type: 'improvement',
        label: 'Melhorias',
        count: 2,
        items: [
          { title: 'Transfer com erro em valores inválidos; barra de smilies mais espaçada e responsiva.' },
          { title: 'Chat mais responsivo (incl. embeds pequenos).' },
        ],
      },
      {
        type: 'fix',
        label: 'Correções',
        count: 2,
        items: [
          { title: 'Não registrado sem ID; away atrás do peão no tablet; Safari nas settings.' },
          {
            title: 'Guest-only message; Everypower pawn; 8ball foco; Namewave; amigos aleatórios; estrela no peão; duplicação BFF.',
          },
        ],
      },
    ],
  },
  {
    version: '1.50',
    date: '30 de setembro de 2020',
    sections: [
      {
        type: 'new',
        label: 'Redesign do diálogo de usuário',
        count: 1,
        items: [
          {
            title: 'Layout, wallet, status, avatar menor, @chat, casamento/BFF, tooltips Heart/Plus, etc.',
            details: [
              'Lista “Clear friend” e estados mutuos; ícones no editar perfil; melhor alinhamento sem status.',
            ],
          },
        ],
      },
      {
        type: 'new',
        label: 'Outras novidades',
        count: 3,
        items: [
          { title: 'PM melhorado (ícone X, remetente, envio pela caixa principal).' },
          { title: 'Esconder/mostrar lista de utilizadores.' },
          { title: 'Casamento/BFF/divórcio: ícones Heart/Plus e mais beijos.' },
        ],
      },
      {
        type: 'powers',
        label: 'Powers',
        count: 2,
        items: [
          { title: 'Namegrad/wave padrão arco-íris no HTML5.' },
          { title: 'Mirror/Invert corrigido; Typing; Zoom; mistura de stickers com aspas; diálogo de powers.' },
        ],
      },
      {
        type: 'improvement',
        label: 'Definições e misc.',
        count: 2,
        items: [
          { title: 'Xavi on/off; ocultar palavras inadequadas; sign in automático.' },
          {
            title: 'Eventos, wallet em gifts/kisses, reconectar mostra só você na lista, mute como ban, transfer em diálogo.',
          },
        ],
      },
      {
        type: 'fix',
        label: 'Firefox / Safari',
        count: 1,
        items: [
          {
            title: 'Correções de abas, gifts, espaçamento da caixa de texto, seleção de links, Ubuntu PM cor, animação de peões.',
          },
        ],
      },
    ],
  },
  {
    version: '1.49',
    date: '4 de julho de 2020',
    sections: [
      {
        type: 'new',
        label: 'Novidades',
        count: 2,
        items: [
          {
            title: 'Markdown',
            details: ['Negrito/itálico/riscado/link e citar mensagens.'],
          },
          {
            title: '8ball',
            details: ['Botão voltar; smilies “other” com gback; busca e smiley principal destacado.'],
          },
        ],
      },
      {
        type: 'improvement',
        label: 'Melhorias',
        count: 2,
        items: [
          { title: 'Scrollbar no Firefox; loader no 8ball; busca de amigos por regname; RTL com /rtl /ltr.' },
          { title: 'Nomes até 512 caracteres com códigos (senão limite 90).' },
        ],
      },
      {
        type: 'fix',
        label: 'Correções',
        count: 1,
        items: [
          { title: '8ball para não registrados; tooltip fantasma; envio de mensagens após YouTube.' },
        ],
      },
    ],
  },
  {
    version: '2020-06-13',
    date: '13 de junho de 2020',
    sections: [
      {
        type: 'new',
        label: 'Novidades',
        count: 4,
        items: [
          {
            title: 'Timestamps',
            details: ['Ao passar o rato sobre a mensagem, vê quando foi enviada.'],
          },
          { title: 'Seletor de cor (hex) ao editar perfil.' },
          {
            title: 'App Xavi',
            details: ['Itens antigos da loja Flash não migram; alguns itens exigem vários powers Xavi ou powers como Diva/Glasses.'],
          },
          {
            title: 'Powers de grupo',
            details: ['Enviar (gline) etc. e clicar no smiley para atribuir ou desatribuir (melhorias futuras).'],
          },
        ],
      },
      {
        type: 'fix',
        label: 'Correções e ajustes',
        count: 2,
        items: [
          {
            title: 'Gifts: apagar, ler presente, sobreposição na aba stickers; Translator: duplicados, ícone, aspas, prioridade, [too long].',
          },
          {
            title: '8ball shake, linha de smilies vazia, mensagens de banidos ocultas, flood para registrados, Firefox/Edge/links/&/stickers duplicados/tickle/transferência em PC.',
          },
        ],
      },
    ],
  },
  {
    version: '2020-05-18',
    date: '18 de maio de 2020',
    sections: [
      {
        type: 'new',
        label: 'Novidades',
        count: 3,
        items: [
          { title: 'Busca na lista de amigos (por nome ou ID; regname limitado).' },
          {
            title: 'Gifts no 8ball',
            details: ['Ver, enviar e contadores público/privado (ver wiki).'],
          },
          {
            title: 'Stickers',
            details: ['Novo seletor de cores.'],
          },
        ],
      },
      {
        type: 'fix',
        label: 'Correções',
        count: 2,
        items: [
          { title: 'Away ao ficar sem dias; Category com color picker; diálogo de powers mais rápido e limpo na busca.' },
          { title: 'Edge: Enter e ícone de abas; Firefox/Edge espaçamento; volume rádio; underscore em abas PC; glowworm no nome; novos links padrão (auction, store, etc.).' },
        ],
      },
    ],
  },
  {
    version: '2020-04-21',
    date: '21 de abril de 2020',
    sections: [
      {
        type: 'new',
        label: 'YouTube no chat',
        count: 1,
        items: [
          {
            title: 'Vídeo e app multimédia',
            details: [
              'Reproduzir ligações YouTube no chat; mini-janela arrastável/redimensionável; fila e broadcast (ver wiki).',
              'Logo YouTube atualizado.',
            ],
          },
        ],
      },
      {
        type: 'improvement',
        label: 'Melhorias',
        count: 4,
        items: [
          { title: 'Seletor de smilies (8ball): clicar adiciona à caixa de texto.' },
          { title: 'Stickers: cores interior/exterior pelo 8ball.' },
          { title: 'Mark: editor mais simples ao enviar (mark).' },
          { title: 'Zoom e Reverseban corrigidos; transparência do fundo; opção de esconder barra de smilies.' },
        ],
      },
    ],
  },
  {
    version: '2020-04-07',
    date: '7 de abril de 2020',
    sections: [
      {
        type: 'new',
        label: 'Novidades',
        count: 1,
        items: [
          {
            title: 'Diálogos Kiss e Sticker',
            details: ['Acesso pelo 8ball; pré-visualização de kiss; variações de stickers (ver wiki).'],
          },
        ],
      },
      {
        type: 'improvement',
        label: 'Melhorias',
        count: 2,
        items: [
          { title: 'Pequenos ajustes visuais no diálogo de powers.' },
          { title: 'Mensagens em PC guardadas ao fechar a aba até atualizar a página.' },
        ],
      },
    ],
  },
  {
    version: '2020-03-30',
    date: '30 de março de 2020',
    sections: [
      {
        type: 'powers',
        label: 'Powers',
        count: 1,
        items: [{ title: 'Power Zoom adicionado.' }],
      },
      {
        type: 'new',
        label: 'Moderação',
        count: 1,
        items: [
          {
            title: 'Remover mensagem',
            details: ['Mod+ podem apagar mensagens como no Flash; ícone ao passar o rato no nome.'],
          },
        ],
      },
    ],
  },
  {
    version: '2020-03-25',
    date: '25 de março de 2020',
    sections: [
      {
        type: 'new',
        label: 'Novidades',
        count: 2,
        items: [
          {
            title: 'Visualizador de coleções',
            details: ['Escrever (supersummer) etc. e clicar para ver pawns e powers necessários.'],
          },
          { title: 'Tickle implementado com hora e contador em outras abas.' },
        ],
      },
      {
        type: 'fix',
        label: 'Correções (resumo)',
        count: 1,
        items: [
          {
            title: 'Grande pacote: Big, Gscol, Nopc/Nopm, Num, Stickers, Typing, iOS [object HTMLDivElement], /s, smilies grandes, scroll listas, Nopc Flash, status entre chats, peões, ignored mod+, stealth guest, P1 em PC — ver wiki.',
          },
        ],
      },
    ],
  },
  {
    version: '2019-12-22',
    date: '22 de dezembro de 2019',
    sections: [
      {
        type: 'new',
        label: 'Destaques',
        count: 4,
        items: [
          { title: 'Four in a row refeito: design, estatísticas, modo solo com bot, sem Flash.' },
          { title: 'Visitantes que enviam links são avisados de que outros podem não ver.' },
          { title: 'Codeban redesenhado; modo espectador indisponível.' },
          { title: 'Correções: #00000 preto, underscores em blasts, beijos Flash→HTML5, alemão duplicado nas línguas.' },
        ],
      },
    ],
  },
  {
    version: '2019-07-13',
    date: '13 de julho de 2019',
    sections: [
      {
        type: 'improvement',
        label: 'Melhorias e correções',
        count: 2,
        items: [
          {
            title: 'Pré-visualização de powers, campo de texto, mensagens, edição, Big, Announce, Namegrad/Namewave, links em PM visitante, M/B ID, scroll, Firefox peões, pools, avatares GIF — ver wiki.',
          },
          {
            title: 'Getimage7: carregamento de imagens mais rápido.',
          },
        ],
      },
    ],
  },
  {
    version: '2019-01-21',
    date: '21 de janeiro de 2019',
    sections: [
      {
        type: 'powers',
        label: 'Powers',
        count: 2,
        items: [
          { title: 'Gback, Gscol e Gline implementados.' },
          { title: 'Pré-visualização de powers ao clicar no smiley no chat (powers após ID 202).' },
        ],
      },
    ],
  },
  {
    version: '2018-12-09',
    date: '9 de dezembro de 2018',
    sections: [
      {
        type: 'improvement',
        label: 'Destaques',
        count: 3,
        items: [
          { title: 'Editar perfil repaginado: pré-visualização, xats/dias, campos mais largos, rapidez, sem underscores.' },
          { title: 'Lista de powers em duas colunas; estado ao fechar a janela.' },
          { title: 'Friendlist: indicador de pedido de amigo, chat online, NoFollow.' },
        ],
      },
    ],
  },
  {
    version: '2018-05-22',
    date: '22 de maio de 2018',
    sections: [
      {
        type: 'improvement',
        label: 'Destaques',
        count: 2,
        items: [
          {
            title: 'Boot, casamento/BFF, estrela reg/sub, links padrão, /go, avatares clicáveis para xat.me, getstrip6.',
          },
          { title: 'Mensagens não abrem diálogo ao clicar no texto; pequenos ajustes CSS e transferência pela friendlist.' },
        ],
      },
    ],
  },
  {
    version: '2018-03-26',
    date: '26 de março de 2018',
    sections: [
      {
        type: 'new',
        label: 'Novidades',
        count: 1,
        items: [
          {
            title: 'Notificações desktop',
            details: ['Ver artigo na wiki; janela de ban com botões que não transbordam; mensagens com > visíveis; notificações com menções em maiúsculas.'],
          },
        ],
      },
      {
        type: 'fix',
        label: 'Correções',
        count: 1,
        items: [
          {
            title: 'Visitantes recebem ID ao clicar lista; exploits de smilies enormes; links longos; PM mostra offline/gag; diálogo sem botão Ok; overlay mais legível.',
          },
        ],
      },
    ],
  },
  {
    version: '2017-12-07',
    date: '7 de dezembro de 2017',
    sections: [
      {
        type: 'improvement',
        label: 'HTML5 — marco inicial (resumo wiki)',
        count: 1,
        items: [
          {
            title: 'Estabilidade de conexão, abas de PC e PM, kicks/bans, fundos, “Edit Your Chat” para main owner, negrito na friendlist e posicionamento de amigos.',
          },
        ],
      },
    ],
  },
];
